export const ORGANISATION_ROLES_RESOURCE = 'organisationRoles';
export const ORGANISATION_ROLE_RESOURCE = 'organisationRole';
export const CREATE_ORGANISATION_ROLE_RESOURCE = 'createOrganisationRole';
export const UPDATE_ORGANISATION_ROLE_RESOURCE = 'updateOrganisationRole';
export const REMOVE_ORGANISATION_ROLE_RESOURCE = 'removeOrganisationRole';

export const INFINITE_SCROLL = { loader: 'blocked' };
export const ACTIONS = {
  NEW: 'new',
  EDIT: 'edit',
};
export const SORTED = { defaults: { column: 'name', direction: 'ascending' } };
